<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['/']" class="app-logo">
            <!-- Replace the SVG with your logo -->
            <img src="https://dfcapp.s3.amazonaws.com/Dollar-Flight-Club-Logo-Original-2.png" alt="Dollar Flight Club Logo" class="app-logo-normal">
            <img src="https://dfcapp.s3.amazonaws.com/Dollar-Flight-Club-Logo-Original-2.png" alt="Dollar Flight Club Logo" class="app-logo-small">
        </a>
        <button class="layout-sidebar-anchor p-link z-2 mb-2" type="button" (click)="anchor()"></button>
    </div>

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
